import React, { Suspense } from 'react';
import { Provider } from 'react-redux'
import VConsole from 'vconsole';
import routes from './routes';
import './App.css';
import './static/scss/global.scss';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import store from './store';
import { handleUgData } from "./utils/ug";
import { middlePageHooks } from './utils/textConfig';
import { lclog } from './utils/lclog';
import { detectEnv } from './utils/yUtil';

if (window.location.host.startsWith('kandianshare.sparta')
  || window.location.search.includes('vconsole=1')) {
  new VConsole()
}

if (!window._configs) {
  window._configs = {
    // 命中的实验ID
    profileIdMatchList: [],
    smpData: {}
  }
}
window._configs.middlePageHooks = middlePageHooks;

if (!window.appName) {
  handleUgData();
}

function App() {
  lclog.info('sharePageOpen');
  const appEnv = detectEnv();
  if (appEnv.isWeChat) {
    lclog.info('weChatShare');
  } else if(appEnv.isMQQ) {
    lclog.info('qqShare');
  }
  return (
    <Router>
      <Suspense fallback=''>
        <Switch>
          {routes.map((route, i) => (
            <RouteWithSubRoutes key={i} {...route} />
          ))}
        </Switch>
      </Suspense>
    </Router>
  );
}

function RouteWithSubRoutes(route) {
  return (
    <Provider store={store} >
      <Route
        path={route.path}
        render={props => (
          <route.component route={route} />
        )}
      />
    </Provider>
  );
}

export default App;
